// חודש הערך ("נכונות") של קובץ שאינו מסלקה — נגזר לצורך *ברירת מחדל* בלבד;
// המשתמש חייב לאשר/לתקן אותו בבורר החודש בכל יבואן (מקור אמת יחיד).
//
// deriveValueMonth  → "YYYY-MM" (או "" אם לא נמצא)
// monthToValueDate  → "YYYY-MM" → ISO של היום האחרון בחודש ("נכון לסוף החודש")

// ניחוש חודש ערך: תאריך נכונות אמיתי → דפוסים בשם הקובץ → "".
// (מאחד את הלוגיקה שהייתה ב-defaultMonth שב-ManagedPortfolioImport.)
export function deriveValueMonth(fileName, fallbackISODate) {
  if (fallbackISODate) {
    const iso = String(fallbackISODate);
    // ISO: YYYY-MM-DD / YYYY-MM
    let m = iso.match(/^(\d{4})-(\d{2})/);
    if (m) return `${m[1]}-${m[2]}`;
    // DD/MM/YYYY (הפורמט של fmtDate)
    m = iso.match(/^(\d{2})[/\-](\d{2})[/\-](\d{4})/);
    if (m) return `${m[3]}-${m[2]}`;
  }
  const name = String(fileName || "");
  let m = name.match(/(\d{1,2})[._\- ](\d{4})/);   // 4.2026 / 4_2026
  if (m) return `${m[2]}-${m[1].padStart(2, "0")}`;
  m = name.match(/(\d{4})[._\- ](\d{1,2})(?!\d)/);  // 2026-04
  if (m) return `${m[1]}-${m[2].padStart(2, "0")}`;
  m = name.match(/^(\d{2})(\d{2})(\d{2})(?!\d)/);    // 300426 = DDMMYY
  if (m) return `20${m[3]}-${m[2]}`;
  m = name.match(/^(\d{2})(\d{2})(\d{4})/);          // 30042026 = DDMMYYYY
  if (m) return `${m[3]}-${m[2]}`;
  m = name.match(/(\d{1,2})\.(\d{2})(?!\d)/);        // 3.26 = M.YY
  if (m) return `20${m[2]}-${m[1].padStart(2, "0")}`;
  return "";
}

// "YYYY-MM" → תאריך ISO של היום האחרון בחודש (תאריך הערך של ה-snapshot).
export function monthToValueDate(month) {
  if (!month || !/^\d{4}-\d{2}$/.test(month)) return null;
  const [yy, mm] = month.split("-").map(Number);
  const lastDay = new Date(yy, mm, 0).getDate();
  return `${month}-${String(lastDay).padStart(2, "0")}`;
}
